import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import createMuiTheme, { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';
import { TypographyOptions } from '@material-ui/core/styles/createTypography';



declare module '@material-ui/core/styles/createMuiTheme' {

  interface TypographysOptions{
    fontFamily?: String,
    fontSize?: Number,
    fontWeightLight?: Number,
    fontWeightMedium?: Number,
    fontWeightRegular?: Number
  }

  interface Theme {
  }

  // allow configuration using `createMuiTheme`
  interface ThemeOptions {
  }
}

export default function createMyTheme(options: ThemeOptions) {
  return createMuiTheme({
    ...options
  })
}